@if(files().length > 0) {

  <!-- Search box -->
  <div class="search-container">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>{{ "SEARCH" | translate }}</mat-label>
      <input matInput type="text" [(ngModel)]="searchText" (keyup)="applyFilter()"
        placeholder="{{ 'SEARCH_DOCS' | translate }}">
      <mat-icon matPrefix>search</mat-icon>
      @if (searchText) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
    matSortActive="lastOpened" matSortDirection="asc" multiTemplateDataRows class="mat-elevation-z8">

    <!-- Preview Column -->
    <ng-container matColumnDef="preview">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" (click)="selectedFile(element)">
        <img class="preview-image" [src]="element.previewPublicUrl" />
      </td>
    </ng-container>

    <!-- Icon Column -->
    <ng-container matColumnDef="doctype">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" (click)="copyDocId(element)">
        <mat-icon class="material-icon-filled document-list-icon" [ngClass]="getDocIconStyle(element)">{{
          shellStateService.getTypeIcon(element.docType)
        }}</mat-icon>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortingCache sortActionDescription="Sort by name">
        {{ "WORKSPACE_FILENAME_LABEL" | translate }}
      </th>
      <td mat-cell *matCellDef="let element" (click)="selectedFile(element)">
        <div class="horizontal-content">
          <div class="text-ellipsys" [matTooltip]="element.name">{{ element.name }}</div>
        </div>
      </td>
    </ng-container>

    <!-- LastOpened Column -->
    <ng-container matColumnDef="lastOpened">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortingCache sortActionDescription="Sort by date">
        {{ "WORKSPACE_LASTOPENED_LABEL" | translate }}
      </th>
      <td mat-cell *matCellDef="let element" (click)="selectedFile(element)">
        {{ element.lastOpened | date : "dd/MM/yyyy" }}
      </td>
    </ng-container>

    <!-- Share State Column -->
    <ng-container matColumnDef="sharestate">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div class="align-right">
        <mat-icon [matTooltip]="shellStateService.getShareIconTooltip(element)" [class]="
          shellStateService.getShareStateIcon(element) === 'shared'
          ? 'material-icon-rounded-filled'
          : ''
          ">{{ shellStateService.getShareStateIcon(element) }}</mat-icon>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'selected-row': selectedDoc?.id === row.id}"
    (click)="selectedFile(row)" (dblclick)="doubleClickedFile(row)"></tr>
  </table>
} @else {
  <div class="no-content-container">
    @if (type()==='map') {
      <div translate>WORKSPACE_NO_MAPS</div>
    } @else if (type()==='doc') {
      <div translate>WORKSPACE_NO_DOCS</div>
    } @else if (type()==='pdf') {
      <div translate>WORKSPACE_NO_PDFS</div>
    }
  </div>
}